/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from 'react';
import { View, Text, Animated } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';
import { useFocusEffect } from '@react-navigation/native';
import moment from 'moment';
import EventDetails from '@v2/pages/machines/modules/events/components/details/components/EventDetailsComponent';
import CombinedEvent from '@v2/pages/machines/modules/events/components/combined/CombinedEventComponent';
import Header from './header/details';
import SmallHeader from './header/smallDetails';
import DetailsComponent from './detailsComponents';
import EventCharts from './eventsChart';

import Loading from '@components/loading';

import { height, scale } from '@components/frame';
import {
  isPhone,
  isWeb,
  machineDetailsConditions,
  navigateTo,
  machineStatus,
  ncFileStatuses,
  ALL_MACHINES,
  navigateBack,
  Alert,
  timePeriod,
  addQueryParams,
  removeQueryParam,
  localTime,
  chartStatuses,
  controlAPICall,
  parseRouteParamAsNumber,
} from '../../../helpers';

import useStatusBar from '@components/common/useStatusBar';

import { font } from '@styles/fonts';
import ColorWrapper from '@styles/colors';

import { switchMachine, getMachines, setSelectedMachine, getNCFileStatistics } from '@reducers/machines';
import { removeProductionInformation, getNCFileById, setSelectedNCFile } from '@reducers/manufacture';
import { getPartByID } from '@reducers/parts';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';

const Details = (props) => {
  const {
    setModalMissingPIOpen,
    setActionsModalOpen,
    time,
    C,
    detailsWidth,
    switchMachine,
    selectedTime,
    setSelectedTime,
    machinesLoaded,
    route,
    getMachines,
    setSelectedMachine,
    panelViewMode,
    selectedLevel,
    setSelectedLevel,
    selectedPeriod,
    selectedTimeCounter,
    setSelectedPeriod,
    chartData,
    setChartData,
    clampingTools: { clampingTools = [] },
    highlightHeader,
    noMachine,
    lg,
    selectedChartDate,
    selectedChartDateEnd,
    setSelectedChartDate,
    setSelectedChartDateEnd,
    selectedNCFile,
    setSelectedNCFile,
    onBack,
    getPartByID,
    getNCFileById,
    initialLoading,
    ncFileStatistics,
    isGlobalMachineList,
    machineStatistics,
    globalScroll,
    getNCFileStatistics,
    setIsMachinesSelectModalOpen,
  } = props;

  const { isAllSelected, id } = useHandleParams();

  const [alowLoadMore, setLoadMore] = useState(true);
  const [allowLoadMoreBatches, setAllowLoadMoreBatches] = useState(false);
  const [loadBatchesDisabled, setLoadBatchesDisabled] = useState(false);

  const abortControllerNCFile = useRef();

  const [localSelectedNCFile, setLocalSelectedNCFile] = useState(null);
  const [batchText, setBatchText] = useState(null);

  let selectedItem = noMachine ? selectedNCFile : props.selectedItem;

  const [loaded, setLoaded] = useState(selectedItem?.id);

  if (localSelectedNCFile) {
    selectedItem = {
      ...selectedItem,
      machineStatus: {
        ...selectedItem.machineStatus,
        ...localSelectedNCFile,
      },
    };
  }

  const isNCFile = Boolean(selectedItem?.machineStatus?.ncFile);
  const allSelected = selectedItem?.id === ALL_MACHINES || isGlobalMachineList;

  const s = scale;

  const [showEventsList, setShowEventsListInternal] = useState(
    route?.params?.events === 'true' || chartStatuses[String(route?.params?.status).toLocaleLowerCase()] === chartStatuses.events
  );
  const setShowEventsList = (data) => {
    if (data) {
      addQueryParams({ events: data });
    } else {
      removeQueryParam('events');
    }
    setShowEventsListInternal(data);
  };
  const [initialEventDate, setInitialEventDateInternal] = useState(route?.params?.eventsDate ? localTime(route?.params?.eventsDate).format() : null);
  const setInitialEventDate = (data) => {
    if (data) {
      addQueryParams({ eventsDate: localTime(data).format('YYYY-MM-DD') });
    } else {
      removeQueryParam('eventsDate');
    }
    setInitialEventDateInternal(data);
  };

  const [ncDetails, setNcDetailsInternal] = useState(route?.params?.ncFileName ? { name: route?.params?.ncFileName } : null);
  const setNcDetails = (data) => {
    if (data?.name) {
      addQueryParams({ ncFileName: data.name });
    } else {
      removeQueryParam('ncFileName');
    }
    setNcDetailsInternal(data);
  };

  const [eventDetails, setEventDetailsInternal] = useState(
    route?.params?.eventDetailsStart || route?.params?.eventDetailsEnd
      ? {
          sequenceNumberStartedOn: route?.params?.eventDetailsStart,
          sequenceNumberEndedOn: route?.params?.eventDetailsEnd,
        }
      : null
  );
  const setEventDetails = (data) => {
    if (data) {
      addQueryParams({
        eventDetailsStart: data.sequenceNumberStartedOn,
        eventDetailsEnd: data.sequenceNumberEndedOn,
      });
    } else {
      removeQueryParam('eventDetailsStart');
      removeQueryParam('eventDetailsEnd');
    }
    setEventDetailsInternal(data);
  };

  const [combinedEvent, setCombinedEventInternal] = useState(
    route?.params?.combinedEventStart || route?.params?.combinedEventEnd
      ? {
          sequenceNumberStartedOn: route?.params?.combinedEventStart,
          sequenceNumberEndedOn: route?.params?.combinedEventEnd,
        }
      : null
  );
  const setCombinedEvent = (data) => {
    if (data) {
      addQueryParams({
        combinedEventStart: data.sequenceNumberStartedOn,
        combinedEventEnd: data.sequenceNumberEndedOn,
      });
    } else {
      removeQueryParam('combinedEventStart');
      removeQueryParam('combinedEventEnd');
    }
    setCombinedEventInternal(data);
  };

  if (isPhone) {
    useStatusBar({
      C,
      background: C('Background/Light/Detail'),
    });
  }

  useEffect(() => {
    (async () => {
      if (id) {
        const machines = await getMachines(true);
        const exist = machines.find((i) => i.machineId === Number(id));
        if (exist) {
          setSelectedMachine(exist);
        } else {
          const isAll = isAllSelected;
          setSelectedMachine({
            id: isAll ? ALL_MACHINES : Number(id),
            machineStatus: {
              status: 'Active',
            },
            machineStatisticsOnly: !isAll,
            machineStatistics: {},
            needUpdateAfterLoad: true,
          });
          if (isPhone) {
            navigateTo('Authorized');
          }
        }
      }

      const partIdParam = parseRouteParamAsNumber(route?.params?.partId);
      if (partIdParam) {
        const result = await getPartByID(partIdParam);
        const part = result?.searchResult?.[0];
        if (!part) {
          Alert(i18n.t({ title: 'Part not found' }));
          return navigateBack();
        }
        setSelectedNCFile({
          machineStatus: {
            partDetails: part,
          },
        });
      }

      const ncFileIdParam = parseRouteParamAsNumber(route?.params?.ncFileId);
      if (ncFileIdParam) {
        if (selectedItem?.machineStatus?.isSearchData) {
          setLoaded(true);
        }

        const ncFile = await getNCFileById(ncFileIdParam);

        if (!ncFile) {
          Alert(i18n.t({ title: 'NC file not found' }));
          return navigateBack();
        }
        setSelectedNCFile({
          machineStatus: {
            ...ncFile,
            ncFile: ncFile.ncFileName,
            status: machineStatus.NOTPRODUCTIVE,
            partDetails: {
              drawing: ncFile.partDrawingNumber,
              partId: ncFile.partId,
              partName: ncFile.partNumber,
              position: ncFile.partDrawingPosition,
              description: ncFile.partDescription,
              revision: ncFile.partDrawingRevision,
            },
          },
        });
      }

      setLoaded(true);
    })();
  }, []);

  const fadeAnim = useRef(new Animated.Value(0)).current;

  const {
    server: { offset = 0 },
  } = time;

  const prevId = useRef();
  useEffect(() => {
    if (selectedItem?.id && prevId.current && selectedItem?.id !== prevId.current) {
      setNcDetails(false);
      setEventDetails(null);
      setCombinedEvent(null);
    }
    prevId.current = selectedItem?.id;
  }, [selectedItem?.id]);

  useFocusEffect(() => {
    if (isPhone && !selectedItem?.id && !allSelected && !noMachine) {
      return navigateBack();
    }
  });

  if (!machinesLoaded || !loaded) {
    return <Loading />;
  }

  const NotSelected = ({ isMain = false, message }) => {
    return (
      <View
        style={[
          {
            flex: 1,
            height: '100%',
            width: '100%',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          },
          isMain
            ? {
                width: detailsWidth,
              }
            : {
                width: '100%',
                minHeight: s(100),
              },
        ]}
      >
        <Text
          style={[
            {
              color: C('Label / Light / Tertiary'),
              fontWeight: 'normal',
              marginTop: s(-9),
              fontSize: s(28),
              letterSpacing: s(0.6),
              textAlign: 'center',
            },
            font.Body,
          ]}
        >
          {i18n.t(message || 'No Machine Selected')}
        </Text>
      </View>
    );
  };

  if (!selectedItem?.machineStatus?.status && !noMachine && !isGlobalMachineList) {
    return <NotSelected {...{ selectedItem, isMain: true }} />;
  }

  const { status, subStatus, ncFileStatus, ncFile } = selectedItem?.machineStatus || {};

  const { machineActive, ignoredNcFile } = machineDetailsConditions({
    status,
    ncFileStatus,
    subStatus,
    ncFileExist: !!ncFile,
  });

  const showMachineInfo = noMachine && (ncFileStatus ? ncFileStatuses.Linked === ncFileStatus : true) ? true : machineActive;

  const [displayScrollViewLoader, setDisplayScrollViewLoader] = useState(false);

  const renderElement = () => {
    const detailsProps = {
      panelViewMode,
      selectedItem,
      C,
      timeOffset: offset,
      selectedLevel,
      setSelectedLevel,
      selectedPeriod,
      setSelectedPeriod,
      showMachineInfo,
      setModalMissingPIOpen,
      font,
      scale: s,
      noMachine,
      isNCFile,
      lg,
      setLocalSelectedNCFile,
      batchText,
      setBatchText,
      machinesLoaded,
      initialLoading,
      detailsWidth,
      setSelectedMachine,
      setLoadBatchesDisabled,
      allowLoadMoreBatches,
      displayScrollViewLoader,
      setDisplayScrollViewLoader,
    };

    const EventComponent = (
      <EventCharts
        {...{
          lg,
          selectedTime,
          setSelectedTime,
          selectedChartDate,
          setSelectedChartDate,
          selectedChartDateEnd,
          setSelectedChartDateEnd,
          route,
          setShowEventsList,
          C,
          selectedItem,
          id: selectedItem?.id,
          shortName: selectedItem.shortName,
          setInitialEventDate,
          selectedPeriod,
          selectedTimeCounter,
          setSelectedPeriod,
          chartData,
          setChartData,
          ncFileStatistics,
          allSelected,
          showEventsList,
          setEventDetails,
          setCombinedEvent,
          setNcDetails,
          initialEventDate,
          detailsWidth,
          abortControllerNCFile,
        }}
      />
    );

    switch (selectedTime) {
      // TODO: should it be /events route
      case 'day':
        return EventComponent;
      case 'week':
        return EventComponent;
      case 'year':
        return EventComponent;
      case 'month':
        return EventComponent;
      default:
        return <DetailsComponent {...detailsProps} />;
    }
  };

  const headerProps = {
    selectedTime,
    setSelectedTime,
    selectedItem,
    switchMachine,
    fadeAnim,
    setActionsModalOpen,
    selectedLevel,
    setSelectedLevel,
    showMachineInfo,
    panelViewMode,
    clampingTools,
    scale: s,
    font,
    highlightHeader,
    noMachine,
    isNCFile,
    machineActive,
    onBack,
    ignoredNcFile,
    C,
    allSelected,
    selectedPeriod,
    setSelectedPeriod,
    setInitialEventDate,
    setShowEventsList,
    selectedChartDate,
    setIsMachinesSelectModalOpen,
    batchText,
  };

  const isNoMachineInThisPeriod =
    selectedItem.machineStatisticsOnly && machineStatistics.loaded && !machineStatistics.data?.find((i) => i.machineId === selectedItem.machineId);

  if (
    (selectedTime === timePeriod.NOW && allSelected) ||
    (selectedTime === timePeriod.NOW && selectedItem.machineStatisticsOnly) ||
    isNoMachineInThisPeriod
  ) {
    let message = '';
    if (selectedTime === timePeriod.NOW) {
      if (allSelected) {
        message = 'No Machine Selected';
      }
      if (selectedItem.machineStatisticsOnly) {
        message = 'Previous selected machine does not exist at the moment';
      }
    }

    if (isNoMachineInThisPeriod) {
      message = 'Previous selected machine is not Productive in selected period';
    }

    return (
      <View
        key="MachinesDetails"
        style={[
          {
            flex: 1,
            backgroundColor: C('Background/Light/Detail'),
            width: isPhone ? '100%' : detailsWidth,
          },
        ]}
      >
        <View
          style={[
            isPhone
              ? { flex: 1 }
              : {
                  width: '100%',
                  flex: 1,
                },
          ]}
        >
          <Header
            {...{
              ...headerProps,
              hideName: allSelected,
              onlyTime: true,
              onBack: () => {
                if (isPhone) {
                  setSelectedMachine({});
                  navigateBack();
                }
              },
            }}
          />
          <NotSelected {...{ selectedItem, isMain: !isPhone, message }} />
        </View>
      </View>
    );
  }
  const isNow = selectedTime == 'now';
  const isBatchLevel = selectedLevel == 'batch';

  const scrollListener = ({ nativeEvent }) => {
    const {
      contentOffset: { y },
    } = nativeEvent;

    const loadMoreNCFiles = !isNow && ['Productive', 'Active'].includes(selectedPeriod);

    const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
      return layoutMeasurement.height + contentOffset.y >= contentSize.height - 500;
    };

    if (isCloseToBottom(nativeEvent) && !allowLoadMoreBatches && !loadBatchesDisabled) {
      setAllowLoadMoreBatches(true);
      setTimeout(() => setAllowLoadMoreBatches(false), 1000);
    }

    if (loadMoreNCFiles && isCloseToBottom(nativeEvent) && alowLoadMore) {
      setLoadMore(false);
      const amount = ncFileStatistics?.data?.length;
      if (amount && ncFileStatistics.isMore) {
        let momentStart = moment();
        if (selectedChartDate) {
          momentStart = moment(selectedChartDate);
        }
        const d = { period: selectedTime, date: momentStart.format(), machineId: selectedItem?.id };
        if (allSelected) {
          delete d.machineId;
        }
        controlAPICall(getNCFileStatistics, d, abortControllerNCFile);
      }
      setTimeout(() => {
        setLoadMore(true);
      }, 1000);
    }
  };

  return [
    // ncDetails && (
    //   <NcDetails
    //     key="NcDetails"
    //     {...{
    //       detailsWidth,
    //       C,
    //       eventDetails,
    //       ncDetails,
    //       setModalMissingPIOpen,
    //       setNcDetails,
    //       selectedLevel,
    //       setSelectedLevel,
    //     }}
    //   />
    // ),
    eventDetails && (
      <EventDetails
        key="EventDetails"
        {...{
          detailsWidth,
          C,
          eventDetails,
          setEventDetails,
          selectedItem,
          setNcDetails,
        }}
      />
    ),
    combinedEvent && (
      <CombinedEvent
        key="CombinedEvent"
        {...{
          detailsWidth,
          C,
          combinedEvent,
          setCombinedEvent,
          setEventDetails,
          selectedItem,
          setNcDetails,
        }}
      />
    ),

    <View
      key="MachinesDetails"
      style={[
        {
          flex: 1,
          backgroundColor: C('Background/Light/Detail'),
          width: isPhone ? '100%' : detailsWidth,
        },
      ]}
    >
      <SmallHeader
        {...{
          ...headerProps,
        }}
      />
      <View
        style={[
          isPhone
            ? { flex: 1 }
            : {
                width: '100%',
                flex: 1,
              },
        ]}
      >
        <Animated.ScrollView
          ref={globalScroll}
          onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: fadeAnim } } }], { listener: scrollListener, useNativeDriver: false })}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={[
            { backgroundColor: props.C('Background/Light/Detail') },
            isWeb && { height: height },
            isNow && !isBatchLevel && { flex: 1 },
          ]}
        >
          <Header
            {...{
              ...headerProps,
            }}
          />
          <View
            style={[
              isPhone
                ? { flex: 1 }
                : {
                    paddingHorizontal: s(18),
                    width: '100%',
                    flex: 1,
                  },
            ]}
          >
            <View style={[isPhone ? { flex: 1 } : { width: '100%', flex: 1, marginTop: s(panelViewMode ? 5 : 15) }]}>{renderElement()}</View>
          </View>
        </Animated.ScrollView>
        {displayScrollViewLoader && (
          <View style={{ position: 'absolute', bottom: scale(20), left: '50%', transform: [{ translateX: '-50%' }] }}>
            <Loading background={'transparent'} />
          </View>
        )}
      </View>
    </View>,
  ];
};

const mapStateToProps = ({
  machines: { selectedItem, blobAccessInfo, machinesLoaded, ncFileStatistics, machineStatistics },
  clampingTools,
  time,
  manufacture: { selectedNCFile },
}) => ({
  selectedItem,
  blobAccessInfo,
  time,
  machinesLoaded,
  clampingTools,
  selectedNCFile,
  ncFileStatistics,
  machineStatistics,
});

export default connect(mapStateToProps, {
  switchMachine,
  removeProductionInformation,
  getMachines,
  setSelectedMachine,
  getNCFileById,
  getPartByID,
  setSelectedNCFile,
  getNCFileStatistics,
})(ColorWrapper(Details));
